/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PlanLocalisationClasseSearch
 */
export interface PlanLocalisationClasseSearch {
    /**
     * 
     * @type {number}
     * @memberof PlanLocalisationClasseSearch
     */
    idPlanLocalisation?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    codeConseiller?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    codeMetier?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    gestionInterne?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    idDegre?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    idStatutLocalisation?: BooleanSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    typeCours?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    specificite?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationClasseSearch
     */
    genre?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlanLocalisationClasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PlanLocalisationClasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PlanLocalisationClasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PlanLocalisationClasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PlanLocalisationClasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PlanLocalisationClasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PlanLocalisationClasseSearch interface.
 */
export function instanceOfPlanLocalisationClasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlanLocalisationClasseSearchFromJSON(json: any): PlanLocalisationClasseSearch {
    return PlanLocalisationClasseSearchFromJSONTyped(json, false);
}

export function PlanLocalisationClasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanLocalisationClasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idPlanLocalisation': !exists(json, 'idPlanLocalisation') ? undefined : json['idPlanLocalisation'],
        'codeConseiller': !exists(json, 'codeConseiller') ? undefined : TextSearchFromJSON(json['codeConseiller']),
        'codeMetier': !exists(json, 'codeMetier') ? undefined : TextSearchFromJSON(json['codeMetier']),
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'gestionInterne': !exists(json, 'gestionInterne') ? undefined : TextSearchFromJSON(json['gestionInterne']),
        'idDegre': !exists(json, 'idDegre') ? undefined : TextSearchFromJSON(json['idDegre']),
        'idStatutLocalisation': !exists(json, 'idStatutLocalisation') ? undefined : BooleanSearchFromJSON(json['idStatutLocalisation']),
        'typeCours': !exists(json, 'typeCours') ? undefined : TextSearchFromJSON(json['typeCours']),
        'specificite': !exists(json, 'specificite') ? undefined : TextSearchFromJSON(json['specificite']),
        'genre': !exists(json, 'genre') ? undefined : TextSearchFromJSON(json['genre']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PlanLocalisationClasseSearchToJSON(value?: PlanLocalisationClasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idPlanLocalisation': value.idPlanLocalisation,
        'codeConseiller': TextSearchToJSON(value.codeConseiller),
        'codeMetier': TextSearchToJSON(value.codeMetier),
        'nom': TextSearchToJSON(value.nom),
        'gestionInterne': TextSearchToJSON(value.gestionInterne),
        'idDegre': TextSearchToJSON(value.idDegre),
        'idStatutLocalisation': BooleanSearchToJSON(value.idStatutLocalisation),
        'typeCours': TextSearchToJSON(value.typeCours),
        'specificite': TextSearchToJSON(value.specificite),
        'genre': TextSearchToJSON(value.genre),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

